import { editSubGroup, deleteSubGroup } from 'api/management'
import { EditSubGroupUsersPayload } from 'api/management'
import { useConfirm, useAlert } from 'hooks/useDialog'
import { useForm, FormProvider } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'

import { useLoaderData } from './GroupConfig.loader'
import GroupFormFields from './GroupFormFields'
import NotFoundMessage from './NotFoundMessage'

export default function GroupEdit() {
  const navigate = useNavigate()
  const confirm = useConfirm()
  const alert = useAlert()
  const nameDecoded = decodeURIComponent(atob(useParams().name!))
  const { users, subGroups } = useLoaderData()
  const currentGroup = subGroups.find((x) => x.name === nameDecoded)
  const currentUsers = users.filter((x) => x.subGroups.includes(nameDecoded))
  const form = useForm({
    defaultValues: {
      name: currentGroup?.name,
      operationFlowType: currentGroup?.operationFlowType,
      users: currentUsers,
    },
  })
  const { reset } = form

  const handleSave = async (data: EditSubGroupUsersPayload) => {
    try {
      await editSubGroup(data)
      alert({ message: 'グループ設定が保存されました' })
      navigate('..')
    } catch {
      alert({ message: 'グループ設定の保存が失敗しました' })
    }
  }

  const handleDel = () => {
    confirm({
      message: [
        'このグループを削除しますか？',
        'このグループを設定している帳票、文書タイプは全て削除されます',
      ],
      actionText: '削除',
      cancelText: 'キャンセル',
      actionProps: {
        color: 'secondary',
      },
      onConfirm: async () => {
        try {
          reset() // reset error, dirty form status
          await deleteSubGroup(currentGroup!.name)
          alert({ message: 'グループが削除されました' })
          navigate('..')
        } catch {
          alert({ message: 'グループ削除が失敗しました' })
        }
      },
    })
  }

  if (!nameDecoded) return <div />

  if (!currentGroup) {
    return <NotFoundMessage />
  }

  return (
    <FormProvider {...form}>
      <GroupFormFields
        title={'グループ設定の編集'}
        mode={'edit'}
        onSave={handleSave}
        onDel={handleDel}
      />
    </FormProvider>
  )
}
